import { useTranslation } from 'react-i18next'
import { Typography, useTheme } from '@mui/material'
import { MdDelete } from 'react-icons/md'
import { useCustomerCtx, useDialogCtx } from '../../../../hooks/context-hooks'
import { getThemeColor } from 'src/utils'
import { MUIThemeColors } from 'src/mui-theme'
import { Flex } from 'src/styles/flexComponent'
import TaskDeleteDialog from './TaskDeleteDialog'
import { TaskTypes } from 'src/enums'

const TaskDeleteButton = ({ task, customerId: customerIdProp }: { task: any; customerId?: EntityId }) => {
  const { t } = useTranslation('task')
  const customerCtx = useCustomerCtx()
  const customerId = customerIdProp ?? customerCtx?.customer?.id
  const { showDialog } = useDialogCtx()
  const theme = useTheme()

  const onDelete = () => {
    showDialog(
      TaskDeleteDialog,
      {
        componentProps: {
          taskId: task.id,
          localityId: task.localityId,
          customerId: customerId,
          hasOngoingScheduledTasks: task.hasOngoingScheduledTasks && task.type == TaskTypes.Repeatable,
        },
        opts: {
          maxWidth: 'sm',
          fullWidth: true,
        },
        title: t('delete-task'),
      },
      undefined,
      false,
    )
  }

  return (
    <Flex.Row onClick={onDelete} gap={1}>
      <MdDelete size={24} />
      <Typography color={getThemeColor(theme, MUIThemeColors.black)}>{t('delete', { ns: 'common' })}</Typography>
    </Flex.Row>
  )
}

export default TaskDeleteButton
